module.exports = __webpack_public_path__ + "img/posologie-mathild-schema.a45733fb.png";